import AffiliateTripaneer from 'screens/AffiliateTripaneer'
// import AffiliateBookRetreats from 'screens/AffiliateBookRetreats'

const Retreats = () => {
  return <AffiliateTripaneer type="retreats" />
  // return <AffiliateBookRetreats type="retreats" />
}

export default Retreats
